const watchEvents = () => {

  let accordians = document.querySelectorAll('.accordian__unitTitle');


  Array.prototype.forEach.call(accordians, (accordian) => {

    let timesClicked = 0;

    accordian.addEventListener('click', () => {

      timesClicked++;

      accordian.parentElement.lastElementChild.classList.toggle('accordian__unitContent--active');

      if (timesClicked %2 == 0) {
        accordian.lastChild.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M7.467 0v7.467H0v1.066h7.467V16h1.066V8.533H16V7.467H8.533V0z" fill="#222B32" fill-rule="evenodd"/></svg>';
      } else {
        accordian.lastChild.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="1"><path d="M7.467 0H0v1h16V0H8.533z" fill="#222B32" fill-rule="evenodd"/></svg>';
      }

    });
  });
}

function AccordianComponent () {
  watchEvents();
};

export default AccordianComponent;


// WEBPACK FOOTER //
// ./src/js/app/components/Accordian.js